const teamdata = [
	{
		teamname: "Fest Coordinator",
		members: [
			{
				name: "Gaurav Gupta",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/gaurav-gupta.jpeg",
			},

		]
	},
	{
		teamname: "Advisory",
		members: [
			{
				name: "Pratyanshu Prince",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/PXL_20230113_014045139\~3\ -\ Pratyanshu\ Prince.jpg",
			},
			{
				name: "Vani Grover",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/images\ -\ Vani\ Grover.jpeg",
			}

		]
	},
	{
		teamname: "Events",
		members: [
			{
				name: "Anjana Pathari",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/20230903_182101 - Anjana Pathari.jpg",



			},
			{
				name: "Devendra Pratap Singh Rathore",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/devr.jpg",



			}


		]

	},

	{
		teamname: "Media and Public Relations",
		members: [
			{
				name: "Shashikant",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/IMG20240204210913 - Shashikant.jpg",



			},
			{
				name: "Kadavath Tharun",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/IMG_20230919_015729_604\ -\ Kadavath\ Tharun.jpg",



			}
		]
	},
	{
		teamname: "Marketing and Sponsorship ",
		members: [
			{
				name: "Harsh Chandra",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/IMG_20240126_030043_836 - Harsh Chandra.jpg",



			},
			{
				name: "Shriyansh Sinha",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/IMG_8412 - Shriyansh Sinha.jpg",



			},
			{
				name: "Shubham Satyam",
				image:
					"https://deeepkk.github.io/samnivesha/src/assets/team/IMG-20240304-WA0040\ -\ Shubham\ Satyam.jpg",



			}
		]
	}




];

export default teamdata;
